import * as React from 'react';
import { ISideBar, RoutesModules } from 'src/modules/Routing/types';
import { UserTypes } from 'src/modules/Auth/store/types';
import { RouteModuleContext } from 'src/modules/Routing/context/RouteModule';
import { linkSidebars } from 'src/modules/Routing/hooks/sideBars/linkSidebars';

export const useSideBars = (moduleName: RoutesModules): [ISideBar[], UserTypes] => {
  const [modules, userType] = React.useContext(RouteModuleContext)
  const routes = React.useMemo(() => linkSidebars(userType, modules, moduleName), [userType])
  return [routes, userType];
}
